var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKanban = function SvgIconKanban(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 5.25a1 1 0 0 1 1-1h16.5a1 1 0 0 1 1 1V16.5a1.75 1.75 0 0 1-1.75 1.75h-3.75A1.75 1.75 0 0 1 14 16.5v-1.25h-4v4.25a1.75 1.75 0 0 1-1.75 1.75H4.5a1.75 1.75 0 0 1-1.75-1.75zm11.25 1h-4v7h4zm2 4v-4h3.25v4zm0 2v4h3.25v-4zm-8-6H4.75v4H8zm0 6H4.75v7H8z",
    clipRule: "evenodd"
  })));
};
export default SvgIconKanban;